var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countDown",on:{"click":_vm.click}},[_c('span',{staticClass:"text-regular alinhamento",domProps:{"innerHTML":_vm._s(_vm.countDown(_vm.row))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }